import * as React from "react";
const KidneySVG = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 136.78 233.1"
    {...props}
  >
    <defs>
      <style>
        {
          "\n      .cls-1 {\n        fill: #b30000;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37 {\n        fill-rule: evenodd;\n      }\n\n      .cls-38 {\n        stroke-width: .13px;\n      }\n\n      .cls-38, .cls-3, .cls-4, .cls-5, .cls-39, .cls-40, .cls-41, .cls-42, .cls-9, .cls-10, .cls-12, .cls-43, .cls-44, .cls-17, .cls-45, .cls-46, .cls-21, .cls-22, .cls-23, .cls-24, .cls-47, .cls-48 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-38, .cls-3, .cls-49, .cls-9, .cls-12, .cls-17, .cls-18, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-47 {\n        stroke: #000;\n      }\n\n      .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-49, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48 {\n        fill: none;\n      }\n\n      .cls-38, .cls-45, .cls-46, .cls-48 {\n        stroke-linecap: round;\n      }\n\n      .cls-2 {\n        fill: #f4f4bc;\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3, .cls-12, .cls-17, .cls-21, .cls-22, .cls-23, .cls-24, .cls-47 {\n        stroke-width: .13px;\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-4, .cls-5 {\n        stroke: #870000;\n        stroke-width: .13px;\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-6 {\n        fill: #ac0000;\n      }\n\n      .cls-39, .cls-40, .cls-41, .cls-42, .cls-48 {\n        stroke: #30006e;\n      }\n\n      .cls-39, .cls-48 {\n        stroke-width: .43px;\n      }\n\n      .cls-40 {\n        stroke-width: .52px;\n      }\n\n      .cls-41, .cls-44, .cls-46 {\n        stroke-width: .51px;\n      }\n\n      .cls-42 {\n        stroke-width: .38px;\n      }\n\n      .cls-7 {\n        fill: #b50000;\n      }\n\n      .cls-8 {\n        fill: #e00000;\n      }\n\n      .cls-49 {\n        stroke-width: .2px;\n      }\n\n      .cls-50, .cls-19, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-51 {\n        isolation: isolate;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-10);\n        stroke-width: .14px;\n      }\n\n      .cls-10 {\n        fill: #cf7a01;\n        stroke: #640000;\n        stroke-width: .71px;\n      }\n\n      .cls-11 {\n        fill: #b40000;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-43 {\n        stroke-width: .51px;\n      }\n\n      .cls-43, .cls-44, .cls-45, .cls-46 {\n        stroke: #e00000;\n      }\n\n      .cls-14 {\n        fill: rgba(255, 255, 255, .5);\n      }\n\n      .cls-15 {\n        fill: #30006e;\n      }\n\n      .cls-16 {\n        fill: #b20000;\n      }\n\n      .cls-17, .cls-20 {\n        fill: #fac661;\n      }\n\n      .cls-18 {\n        fill: #eb8f90;\n        stroke-width: .54px;\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-19, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33 {\n        opacity: .43;\n      }\n\n      .cls-45 {\n        stroke-width: .57px;\n      }\n\n      .cls-20 {\n        stroke-width: .18px;\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-22 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-23 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-24 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-25 {\n        fill: rgba(255, 255, 255, .35);\n      }\n\n      .cls-26 {\n        fill: #b10000;\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-51 {\n        fill: #861d00;\n        font-family: ArialMT, Arial;\n        font-size: 2.11px;\n      }\n\n      .cls-34 {\n        fill: #800;\n      }\n\n      .cls-35 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-36 {\n        fill: #ef7e7e;\n      }\n\n      .cls-37 {\n        fill: #8d1d00;\n      }\n    "
        }
      </style>
      <linearGradient
        id="linear-gradient"
        x1={-1740}
        y1={9391.64}
        x2={-1699.68}
        y2={9427.29}
        gradientTransform="translate(-693.91 -193.04) rotate(111.93) scale(.09 -.09) skewX(5.8)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#c10000" />
        <stop offset={0.5} stopColor="#7c0000" />
        <stop offset={0.5} stopColor="#c10000" />
        <stop offset={0.88} stopColor="#9e0000" />
        <stop offset={0.88} stopColor="#c10000" />
        <stop offset={0.97} stopColor="#910000" />
        <stop offset={1} stopColor="#c10000" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1={9783.1}
        y1={1150.68}
        x2={9823.41}
        y2={1186.33}
        gradientTransform="translate(-599.12 -146.62) rotate(25.62) scale(.08 -.1) skewX(-15.28)"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-3"
        x1={-1097.71}
        y1={9470.93}
        x2={-1057.4}
        y2={9506.58}
        gradientTransform="translate(-691.97 -215.69) rotate(108.89) scale(.09 -.09) skewX(4.64)"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-4"
        x1={-1235.66}
        y1={-8584.84}
        x2={-1195.34}
        y2={-8549.19}
        gradientTransform="translate(-566.91 -284.03) rotate(-76.15) scale(.09 -.09) skewX(2.49)"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-5"
        x1={4710.76}
        y1={-1311}
        x2={4681.68}
        y2={-1353.5}
        gradientTransform="translate(-558.99 -136.22) scale(.14 -.14)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#000" />
        <stop offset={1} stopColor="#fff4b7" stopOpacity={0.48} />
      </linearGradient>
      <radialGradient
        id="radial-gradient"
        cx={4214.98}
        cy={-1225.55}
        fx={4214.98}
        fy={-1225.55}
        r={16.02}
        gradientTransform="translate(-528.06 -138.37) scale(.15 -.15)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#000" />
        <stop offset={1} stopColor="#a47a48" />
      </radialGradient>
      <radialGradient
        id="radial-gradient-2"
        cx={4059.55}
        cy={-404.38}
        fx={4059.55}
        fy={-404.38}
        r={10.48}
        gradientTransform="translate(-524.94 -65.74) scale(.16 -.25)"
        xlinkHref="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-3"
        cx={4607.06}
        cy={-1006}
        fx={4607.06}
        fy={-1006}
        r={3.59}
        gradientTransform="translate(-559.29 -126.76) scale(.14 -.15)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#2f0000" />
        <stop offset={1} stopColor="#be0000" />
      </radialGradient>
      <linearGradient
        id="linear-gradient-6"
        x1={6018.35}
        y1={-6110.98}
        x2={6058.66}
        y2={-6075.33}
        gradientTransform="translate(-644.87 -174.04) rotate(68.07) scale(.09) skewX(5.8)"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-7"
        x1={-9241.4}
        y1={-5077.45}
        x2={-9201.09}
        y2={-5041.8}
        gradientTransform="translate(-739.66 -127.62) rotate(154.38) scale(.08 .1) skewX(-15.28)"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-8"
        x1={5509.88}
        y1={-6483.27}
        x2={5550.2}
        y2={-6447.62}
        gradientTransform="translate(-646.81 -196.69) rotate(71.11) scale(.09) skewX(4.64)"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-9"
        x1={-5837.6}
        y1={7994.23}
        x2={-5797.29}
        y2={8029.88}
        gradientTransform="translate(-771.87 -265.03) rotate(-103.85) scale(.09) skewX(2.49)"
        xlinkHref="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-10"
        x1={-5793.15}
        y1={-1403.82}
        x2={-5776.75}
        y2={-1403.82}
        gradientTransform="translate(-779.79 -117.22) rotate(-180) scale(.14)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#4f4f4f" />
        <stop offset={1} stopColor="#de953e" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-11"
        x1={-5612.05}
        y1={-1311}
        x2={-5641.13}
        y2={-1353.5}
        gradientTransform="translate(-779.79 -117.22) rotate(-180) scale(.14)"
        xlinkHref="#linear-gradient-5"
      />
      <radialGradient
        id="radial-gradient-4"
        cx={-5563.95}
        cy={-1225.55}
        fx={-5563.95}
        fy={-1225.55}
        r={16.02}
        gradientTransform="translate(-810.73 -119.37) rotate(-180) scale(.15)"
        xlinkHref="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-5"
        cx={-5381.75}
        cy={-404.38}
        fx={-5381.75}
        fy={-404.38}
        r={10.48}
        gradientTransform="translate(-813.84 -46.74) rotate(-180) scale(.16 .25)"
        xlinkHref="#radial-gradient"
      />
      <radialGradient
        id="radial-gradient-6"
        cx={-5715.76}
        fx={-5715.76}
        r={3.59}
        gradientTransform="translate(-779.49 -107.76) rotate(-180) scale(.14 .15)"
        xlinkHref="#radial-gradient-3"
      />
      <radialGradient
        id="radial-gradient-7"
        cx={-258.71}
        cy={912.42}
        fx={-258.71}
        fy={912.42}
        r={14.54}
        gradientTransform="translate(-1728.63 686.15) rotate(87.92) scale(1.66 -1.98)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f3adab" />
        <stop offset={1} stopColor="#f3adab" stopOpacity={0} />
      </radialGradient>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <g id="g6092">
        <path
          id="path5810"
          className="cls-20"
          d="M88.68,65.11c1.95,7.47,11.51,43.28,13.9,66.79.83,8.17-9.5,35.33-11.31,43.34-.75,3.34-8.06,8.88-8.37,12.29-.11,1.16,2.03,1.34,1.98,1.9-.18,2.29,7.44-8.66,8.25-12.79,3.15-16.06,13.41-31.81,11.96-46-1.69-16.46-14.35-65.65-14.35-65.65,0,0-2.59-1.93-2.06.11Z"
        />
        <g id="g6095">
          <path
            id="path6097"
            className="cls-8"
            d="M93.66,32.5c-.08-.02-2.12-1-1.43-1.01.69-.02,2.69-.72,2.81-.78.11-.06,1.04.61.85.8-.2.2-2.15,1.01-2.23.99Z"
          />
          <path
            id="path6099"
            className="cls-36"
            d="M92.51,31.58c.27.03.45,0,.79.46.09.18.53-.51,1.63-.7-.22-.19-2.32.19-2.42.24Z"
          />
          <path
            id="path6101"
            className="cls-37"
            d="M91.56,20.33C91.94,6.75,102.36.78,109.88.1c24.99-.22,26.93,29.35,26.77,44.97-.26,24.45-12.57,34.45-23.71,35.85-5.15.4-20.53-4.09-20.11-19.94,2.18-14.1,9.67-14.29,11.45-17.35,4.11-20.63-13.36-.52-12.72-23.29Z"
          />
          <path
            id="path6103"
            className="cls-10"
            d="M92.78,19.81c-.02-7.97,7.13-19.16,17.95-19.46,24.99-.22,25.89,26.81,25.67,39.19-.46,25.58-8.56,35.69-23.12,37.59-3.31.95-20.75,0-19.97-17.51,2.18-13.93,10.4-13.76,12.19-16.79,4.11-20.39-13.21-.51-12.72-23.03Z"
          />
          <path
            id="path6105"
            className="cls-41"
            d="M113.18,27.26c1.03-.48,1.13-1.48,1.72-2.54.31-1.06.89-1.91,1.56-2.65.85-.98,1.38-2.27,1.74-3.62.98-2.37.72-5.3,2.04-7.49.51-1.24,1.59-1.8,2.68-1.6,1.33-.08,3.47-.32,3.9.93.38,1.52,3.04,6.14,3.92,6.68.87.94.61,2.57.44,3.98-.37,1.4.37,2.42,1.13,3.31.53,1.06,1.06,2.27.83,3.57-.23,1.14.02,2.26.5,3.24.49,1.2.39,2.97-.75,3.53-1.14.61-2.43.35-3.63.32-1.25-.34-1.26-2.43-1.03-3.68.15-1.28.9-2.62.47-3.92-.69-.75-.56-.94-.05-2.37.99-.22,1-2.61.24-3.83-.66-1.03-1.19-4.69-1.74-5.84-1-1.07-2.55-.95-3.56-2.03-.81-.98-3.56,1.58-4.59,1.6"
          />
          <path
            id="path6107"
            className="cls-48"
            d="M118.64,16.54c-.09-2.16.13-4.31.48-6.43.13-1.83-1.11-3.31-1.56-5.01-.33-1.59-1.74-2.53-3.29-2.7-1.32-.65-3.47-.06-3.57,1.6.63,1.29,2.53,3,3.74,3.65,1.49.52,3-.97,4.52-1.18,1.21-.44,1.69-2.67,3.23-1.5,1.25.63,2.44,1.53,2.31,3.1.38,1.53,6.45,4.83,5.92,6.6.15,1.9-1.2,3.96-.35,5.74.75,1.32,3.44.42,2.51-1.1-.82-1.29-2.59-.59-3.79-1.2-1.14-.57-2.02-1.69-2.33-2.93"
          />
          <path
            id="path6109"
            className="cls-44"
            d="M111.34,47.23c.87,1.35,1.05,3.23,2.13,4.41.97,1.14,1.79,2.5,2.9,3.43,1.22.64,1.94,1.93,2.69,3.2,1.02,1.3,2.66,1.63,3.5,3.17.51,1.52,2,1.51,2.95,2.37.8.63,1.84,1.45,1.93,2.71-.38,1.17-1.58,1.31-2.45,1.58-1.21.02-1.89,1.21-2.7,2.09-.86,1.04-1.7,2.17-2.87,2.67-1.29.74-2.72,1.16-4.14.91-1.32.07-2.44,1.52-3.81,1.02-1.19,0-2.62-.64-2.71-2.36-.31-1.51,1.07-1.87,1.97-1.71,1.63-.02,3.25.82,4.86.2,1-.26,1.93-.88,2.92-1.14,1.2.4,1.83-.72,2.53-1.62.97-.97,1.24-2.56,2.11-3.63.5-.67.3-1.44.1-2.18"
          />
          <path
            id="path6111"
            className="cls-44"
            d="M109.65,55.75c-.52.37-.06,1.62-.22,2.31.14,1.26-.48,2.28-.67,3.45-.21,1.56.18,3.1.43,4.61.07,1.2-.27,2.52.3,3.6.43.98,1.21,2.03.88,3.23-.23,1.07-1.01,1.83-1.89,1.87-.88.16-1.73-.26-2.55-.57-1-.24-2.02-.36-3-.67-.9-.42-1.96.3-2.72-.47-.98-.86-1.8-1.96-2.71-2.92-.7-.93-1.04-2.38-.55-3.56.65-1.19,1.89-.54,2.46.4.81.84,1.75,1.48,2.4,2.54.83,1.35,2.27,1.53,3.49,1.95.92.18,1.89-.27,2.78.2.72.07,1.65-1.18,1.42-2.05"
          />
          <path
            id="path6113"
            className="cls-41"
            d="M104.66,48.14c-1.23,1.42-1.71,3.71-1.3,5.72.07,1.74-1.22,2.88-1.69,4.41-1.03,1.56-2.94,1.94-4.39,1.13-1.23-.92-2.97.12-2.77,2.03,0,1.34,1.23,1.98,1.28,3.32.06,1.42.41,3.27,1.71,3.62,1.25-.22.66-2.29.61-3.33-.1-1.55-1.33-2.46-1.39-4-.14-1.44.41-2.9,1.31-3.79.93-1.42.95-3.41.76-5.12-.77-1.22-1.48.41-1.73,1.28-.61,1.56-1.22,3.12-1.77,4.71-.41,1.17-.04,3.7,1.31,3.18.59-.38.75-1.73,1.6-1.44"
          />
          <path
            id="path6115"
            className="cls-15"
            d="M90.84,36.15c1.54-.35,7.42-.82,8.85-1.31,1.39-.52,2.36-1.89,3.14-3.34.84-1.4,6.44-10.04,4.65-20.52.19-.67.51-1.35.88-.42-.5,1.47,1.57,6.73-2.72,18.57-2,3.06-4.57,7.6-2.84,8,2.19,1.32,6.17,6.49,6.88,7.92,1.27,1.85,2.22,4.02,3.02,6.22-1.19-.74-1.84-2.8-2.78-4.1-.84-1.48-8.55-10.4-8.28-8.47,1.28,1.35,2.21,3.42,2.99,5.2.67,2.19,1.3,8.61.1,7.61-.21-.47-.01-2.89-.29-3.82-.47-1.67-.75-3.6-1.73-5.01-.93-1.64-2.3-1.35-3.84-1.81-1.87-.31-5.79.48-7.64-.08-2.42-.53-1.88-4.58-.38-4.64Z"
          />
          <path
            id="path6117"
            className="cls-44"
            d="M106.2,48.42c-.33-.86-.85.7-1.06,1.08-.5,1.1-.91,2.28-1.17,3.51-.48.91-.77,2.01-1.48,2.69-.44.61-.8,1.37-1.47,1.61-.95.6-2.01.99-3.08.8-.79.02-1.56-.15-2.12-.91-.63-.73-.53-2.08-.06-2.9.59-.61,1.45-1.03,1.55-2.14.39-.76.51-1.89,1.16-2.35,1.08-.28,1.17,1.43,1.13,2.36-.07.94-.38,1.82-.7,2.66-.44.86-1.04,1.6-1.33,2.58-.5.87-.93,1.85-.86,2.97-.06,1.2.47,2.23.83,3.29.28.79.73,1.46,1.2,2.08.48,1.17-.61,2.1-1.46,2.05-.85.2-1.94.04-2.14-1.23-.3-.86-.49-1.75-.48-2.7-.06-1.57.03-3.13,0-4.7,0-.97.3-2.27,1.21-2.41.66-.1,1.13.76,1.44,1.35"
          />
          <path
            id="path6119"
            className="cls-19"
            d="M104.66,52.16c-.86-.58-3.34-1.64-3.87-1.7-1.25.48-1.41,6.71-.35,7.36,1.41.28,2.57-1.76,4.52-1.97.18-.54.53-2.68-.3-3.69Z"
          />
          <path
            id="path6121"
            className="cls-16"
            d="M118.98,54.06c1.5.53,4.38,3.85,5.1,4.26,2.07.11,4.2-4.92,4.61-7.11.1-.86-.37-2.56-.08-3.44.78-2.27-7.14-.14-8.1.89-.59.65-1.57,4.87-1.53,5.4Z"
          />
          <path
            id="path6123"
            className="cls-11"
            d="M119.51,42.27c1.52.21,4.85,2.69,5.61,2.95,2-.32,3.19-5.7,3.22-7.94-.05-.87-.79-2.44-.65-3.36.36-2.39-6.87.52-7.62,1.72-.45.76-.69,6.11-.56,6.63Z"
          />
          <path
            id="path6125"
            className="cls-34"
            d="M119.46,41.26l6.04,3.47c2.98-3.02,2.27-8.34,1.51-11.57l-7.52,2.92,6.91-1.46-7.08,2.1,7.22-.78-7.45,1.55,7.69-.15-7.91.76,7.95.44-7.97.24,8.04,1.17-7.9-.77,7.65,2.14-7.42-1.59,7.13,2.77-7.07-2.04,6.61,3.02-6.42-2.22Z"
          />
          <path
            id="path6127"
            className="cls-26"
            d="M120.35,30.42c1.4-1,5.79-1.3,6.57-1.67,1.48-1.81-.21-8.24-1.54-10.17-.56-.7-.75-.55-1.19-1.44-1.14-2.32-6.86,6.46-6.76,8.06.08.99,2.5,4.88,2.92,5.22Z"
          />
          <path
            id="path6129"
            className="cls-34"
            d="M120.25,29.76l6.72-1.35c1.28-4.05-1.36-9-3.51-11.53l-5.42,7.04,5.96-5.42-6.31,6.26,7.13-5.12-7.2,5.92,7.82-4.68-7.88,5.53,8.5-4.41-8.15,5.01,8.66-3.65-8.29,4.35,8.72-3.02-8.28,3.84,8.3-2.59-7.7,3.12,7.61-1.64-6.67,2.34Z"
          />
          <path
            id="path6131"
            className="cls-1"
            d="M113.37,22.72c.46-2.04,3.31-5.95,3.66-6.93.12-2.83-4.13-5.8-5.99-6.4-.73-.15-2.18.48-2.92.06-1.92-1.09-.18,9.77.68,11.1.54.81,4.11,2.21,4.57,2.16Z"
          />
          <path
            id="path6133"
            className="cls-34"
            d="M112.86,21.88l4.08-6.45c-2.94-4.59-6.22-6.24-9.3-5.53l.67,10.45.35-9.96-.14,10,1.37-9.77-.87,10.05,2.01-9.74-1.54,10.2,2.97-9.75-2.45,9.76,3.41-8.54-2.78,8.93,3.85-8.25-3.06,8.23,3.95-7.57-3.28,7.68,3.94-6.96-3.18,7.2Z"
          />
          <path
            id="path6135"
            className="cls-7"
            d="M108.44,20.06c-.89-1.31-1.71-5.89-2.08-6.65-1.46-1.26-4.93,2.01-6.08,3.73-.4.71-.71,2.49-1.26,3.1-1.43,1.58,5.14,4.13,6.24,3.76.67-.25,3.01-3.44,3.18-3.94Z"
          />
          <path
            id="path6137"
            className="cls-34"
            d="M107.88,21.59l-1.89-8.06c-3.6-.52-5.8,4.92-6.99,7.4l6,3.13-5.28-4.04,5.22,3.38-4.58-4.27,5.17,4.15-4.78-5.02,5.44,4.76-4.83-5.73,5,5.35-4.39-6.3,4.68,5.94-3.87-6.65,4.48,7.06-3.32-7.72,3.41,6.77-2.49-7.34,3.01,7.18Z"
          />
          <path
            id="path6139"
            className="cls-27"
            d="M107.7,57.58c-.38,1.12-.99,4.3-.98,4.96.5,1.51,5.5,1.09,5.91-.28.09-1.77-1.65-3.02-2.02-5.42-.45-.17-2.2-.4-2.92.74Z"
          />
          <path
            id="path6141"
            className="cls-28"
            d="M104.92,24.88c-.89-.51-3.41-1.38-3.94-1.4-1.23.57-1.07,6.81.01,7.38,1.42.18,2.48-1.95,4.42-2.32.15-.56.4-2.72-.49-3.66Z"
          />
          <path
            id="path6143"
            className="cls-29"
            d="M115.11,36c.93.39,3.51.93,4.04.88,1.17-.73.49-6.91-.63-7.33-1.42.01-2.3,2.27-4.2,2.88-.11.57-.17,2.76.79,3.58Z"
          />
          <path
            id="path6145"
            className="cls-45"
            d="M112.89,26.34c1.21-.42,2.75-2.12,3.35-3.76.36-.88,3.8-3.98,4.08-4.96,1-2.08,2.31-4.19,2.18-6.59,0-1.72-.49-5.35-.55-5.43"
          />
          <path
            id="path6147"
            className="cls-34"
            d="M119.68,53.07l4.58,4.93c3.63-2.2,3.86-7.62,3.91-10.95l-6.88,1.61,6.31-.25-6.64.83,6.45.48-6.9.06,6.78,1.35-7.19-.62,6.94,1.8-6.81-1.33,6.54,2.71-6.52-2.17,5.95,3.43-6.81-3.35,6.24,4.43-5.61-3.51,4.92,4.35-5.26-3.82Z"
          />
          <path
            id="path6149"
            className="cls-17"
            d="M88.57,64.65c.51-4.98,1.45-20.67,13.25-31.68,2.28-1.79,4.59-3.69,1.08-9.15,2.46.3,4.27-2.33,4.74-5.84,1.18,4.96,8.14,1.1,6.58,3.48-1.3,1.6-1.85,7.49-.17,5.9,1.45-.64,2.54-5.43,3.89-3.7.2,1.91,1.62,4.9,3.21,6.29.3,2.79-5,1.76-6.04,3.45.28,2.03,4.77.55,6.07,1.19-2.2,4.02-1.16,5.88-.81,9.37-1.17-1.11-8.51-5.63-7.96-2.37.58,2.62,2.98,3.25,4.81,3.91,1.31.55,4.47.11,4.67,2.23-1.67,2.09-1.96,5.16-1.35,7.99-2.15.54-5.25-3.75-6.37-5.58-.68-2.41-4.09-1.63-2.83,1.08,1.34,2.07,1.61,3.05,3.45,4.78,1.9,1.45,4.1,3.81,2.94,4.47-.76.76-2.86.92-4.29,2.97-.75,1.07-1.77-3.32-2.76-4.74-1-2.11-1.17-2.5-2.07-.35-.55,1.88-1.65,3.89-2.32,5.37-1.75-3.14-7.23-2.03-3.8-4.72,1.79-2.21,2.6-5.48,3.05-9.03-.24-1.86-1.49-3-2.75-3.91-8.44-6.08-12.58,16.36-12.02,19.18-.22-1.07-1.72-1.66-2.22-.59Z"
          />
          <path
            id="path6151"
            className="cls-21"
            d="M101.79,60.24c.19.89,2.65.9,4.48,2.57.66-.62,2.05-5,2.77-5.96.78-.74,1.55.31,1.68,1.25.5.94,1.06,1.83,1.47,2.85.35.8.83,2.38,1.75,1.52.42-1.24,3.48-1.76,3.35-2.72-.45-1.41-5.77-5.68-6.76-9.59-.21-.9-1.01-1.12-1.66-1.18-.95-.1-1.88.39-2.62,1.09-.58.65-.64,1.67-.73,2.57-.49,2.17-.97,4.47-2.19,6.2-.48.53-1.14.76-1.54,1.4Z"
          />
          <path
            id="path6153"
            className="cls-1"
            d="M112.7,61.98c1.16,1.34.62,5.77.87,6.6,1.3,1.59,5.31.49,6.82-1.95.53-.57,1.33-1.89,1.99-2.32,1.72-1.13-4.3-3.86-5.58-5.18-.18.01-.84-.05-.93.29-.39.01-.61-.04-.76.47-.14.04-1.03.03-.78.49-.65.11-1,.24-1.02.97-.61.16-.55.52-.61.63Z"
          />
          <path
            id="path6155"
            className="cls-6"
            d="M102.65,59.4c-1.18.73-3.97,3.35-4.4,4.06-.38,2.22,5.88,7.88,7.27,6.94,1.26-1.77-.27-5.33,1.1-8.22-.05-.09.08-.36-.23-.34-.1-.13-.05-.38-.35-.45-.13-.16-.11-.43-.45-.5-.24-.14-.13-.4-.52-.5-.05-.24-.17-.53-.58-.45-.31-.12-.11-.42-.61-.35-.08-.18-.24-.36-.62-.2-.17-.17-.41-.04-.61,0Z"
          />
          <path
            id="path6157"
            className="cls-47"
            d="M110.76,37.79c-.48-.17-3.75.08-4.23,1.33"
          />
          <path
            id="path6159"
            className="cls-47"
            d="M110.57,32.71c-.5-.03-2.78-.47-3.2-1.56"
          />
          <path
            id="path6161"
            className="cls-3"
            d="M110.1,42.1c-.26.03-.77.39-1.03.55-.44.27-.48.32-.73.64-.31.39-.2.57-.73.73-.36.11-.2.75-.15,1.01.08.38.82.48,1.1.55.55.14.6-.28.88-.46.22-.14.35-.77.44-1.01.1-.26.54-.43.73-.55.51-.32.29-1.01,0-1.37-.13-.16-.38-.09-.51-.09Z"
          />
          <path
            id="path6163"
            className="cls-47"
            d="M110.65,42.28c-.11-.14-.78-1.65-.77-2.66"
          />
          <path
            id="path6165"
            className="cls-38"
            d="M107.49,45.15c-.16-.26-1.3-1.27-2.46-1.31"
          />
          <path
            id="path6167"
            className="cls-2"
            d="M88.68,64.59c.02-4.96,3.48-23.75,13.08-28.98,1.47-1.05,3.11-2.01,4.17-3.71.76-1.78.41-3.96-.38-5.62,2.64,1.69,1.44-3.3,3.12.85.27-6.42,1.46-1.09,2.7-2.99-1.91,3.77,2.74,8.48-.82,5.19-1.47-1.52-8.1,6.09-6.33,7,4.43-2.75,4.21-.72,3.83.9-1.25.18-3.01,1.4-1.93,3.26,1.14,2.83,2.34,1.91.85,3.17-1.02-.03-4.9-2.86-2.7.52,1.02,1.66-.84,1.48-1.44.47-1.53-1.35-3.59-2.58-5.42-1.29-4.98,3.5-6.93,10.83-6.72,21.82-.21-.35-1.26.28-2.01-.59Z"
          />
          <path
            id="path6169"
            className="cls-44"
            d="M104.51,38.99c6.27,3.01,5.01-2.56,10.4,2.79,1.04-.09,6.8,4.1,9.08,3.9.99-.07,2.21.51,3.01-.45.4-.95,1.1-1.66,1.35-2.71.35-1.06.73-2.15.64-3.32.07-1.32-.19-2.72.25-3.97.17-1.27-1.4-1.86-1.06-3.3.19-1.27-.16-3.01.94-3.75,1-.73,2.13-.23,3.17.02,1.2-.49,1.97.87,1.63,2.24.02,1.41-.31,2.91.29,4.21.58,1.19-.22,2.38-.42,3.55-.52,1.26.75,2.24.46,3.54-.3,1.12-1.36,2.12-.93,3.4.77,1.2-.14,2.3-1.17,2.27-.95-.2-1.65-1.35-2.69-1.14-.91.28-1.83.15-2.67-.34-.49-.11-.99,0-1.47-.15"
          />
          <path
            id="path6171"
            className="cls-2"
            d="M120.67,47.36c.36.14.51.76.03.86-2.12,2.73-.61,7.65-2.18,6.13-3.96-2.79-2.62-4.97-5.36-6.43-.24-.2-.28-1.05.26-1.02,5.22,5.98,4.83,1.68,7.24.46Z"
          />
          <path
            id="path6173"
            className="cls-2"
            d="M119.27,42.37c-1.57-2.94,1.27-7.68.01-6.69-3.32,4.4-7.36,2.09-6.82,3.28.98,1.7,3.71.04,6.8,3.4Z"
          />
          <path
            id="path6175"
            className="cls-2"
            d="M120.46,30.21c-2.73-.97-3.03-6.87-3.47-5.09-.23,6.03-4.51,7.54-3.47,8.01,1.63.5,2.84-2.97,6.95-2.92Z"
          />
          <path
            id="path6177"
            className="cls-25"
            d="M90.88,36.51c-.96.48-.92,2.23.17,3.46,1.09,1.03-.27-1.48,2.5-2.32.89-.13,4.2-.4,4.32-1.19-3.67.21-6.26-.02-6.99.04Z"
          />
          <path
            id="path6179"
            className="cls-8"
            d="M88.71,29.07c2.13,1.54,7.07,5.07,9.04,5.15.37.01,4.71,1.19,5.62-5.22,1.12-2.64.1,3.47-.38,3.8-.25.59,2.5-1.33,3.29-2.25,6.03-5.59,10.16-12.37,9-18.86.1-.67-.11-2.29.51-1.17,2.5,6.5-3.67,16.79-10.69,21.96-1.2.95-2.57,1.47-3.85,2.23-.53.14-1.66.68-.68,1.14.88.55,4.39,2.69,5.34,4.42-.37.21-.64.5-3.06-1.33-1.37-1.04-3.34-1.75-5-1.96-1.86-.24-7.82-3.21-10.33-5.06-1.41-1.03-.67-4.19,1.19-2.84Z"
          />
          <path
            id="path6181"
            className="cls-14"
            d="M87.81,31.37c1.75-1.17,7.78,3.68,9.9,3.78,1.35.06,4.13,2.32,3.37,1.51-1.81-1.92-2.42-1.46.75-2.82.48-.21.83-1.2.15-.49-1.32.95-2.87,1.4-4.38,1.16-2.22-.25-6.68-3.7-9.08-5.26-1.69-.73-1.71,2.79-.7,2.12Z"
          />
          <path
            id="path6183"
            className="cls-44"
            d="M115.53,10.32c.02-2.75,2.92-8.9,5.32-5.45,2.04,1.3,4.54,2.04,6.02,4.21.91,4.34,3.98,5.72,4.92,8.66,1.31,3.53,2.71,6.67,1.56,11.39-1.95.39-2.37.39-5.18-2.56-.28-3.85.12-8.7-2.23-11.25-1.24-2.93-5.58-3.01-7.62-4.61-.58-.68-1.97-.48-2.79-.38Z"
          />
          <path
            id="path6185"
            className="cls-44"
            d="M124.5,45.67c-.33-.04-1.39.05-.56.09,1.77.06,3.55.27,5.32.12.82-.36,1.7-.93,2.58-.44.86.49,1.3,1.6,1.92,2.43.65.79.3,1.94-.07,2.79-.64.98.02,2.2-.27,3.27-.58.99-1.19,2.09-1.2,3.36-.09,1.07-1.02,1.58-1.14,2.63-.3,1.27-.91,2.67-2.02,3.02-.92.1-.96,1.51-1.47,2.21-.46,1.12-1.69,1.62-2.56.91-1.08-.67-1.4-2.43-.93-3.75.39-1,.74-2.18,1.68-2.58.77-.54.81-2.05,1.68-2.54.41-.89.79-1.81,1.45-2.46.61-1.01.41-2.34.58-3.51.27-.9.54-1.83.47-2.81-.09-1.01-.79-1.73-1.49-2.09"
          />
          <path
            id="path6187"
            className="cls-40"
            d="M107.44,8.83c-1.63-.41-.64-2.23-2.06-2.99-1.5-.53-3.49-.29-4.28,1.69-.93,1.85-2.91,2.07-3.83,3.95-.88,1.44-1.48,3.14-2.48,4.45.03,1.66.42,3.44-.77,4.61-.22,1.87-.08,4.06.6,5.73,1.06,1.01,3.07,3.27,4.2,1.46.76-2.07-1.13-3.42-1.58-5.19,1.27-2.08,1.38-4.56,1.37-7.08,2.35-.99,2.62-3.05,4.21-3.69,1.54-.93,2.18-2.65,3.92-2.51,1.87-.59.91-1.9.88-3.25.16-2.37,2.21-3.84,3.92-3.4,1.97.27,5.59.28,7.43,1.14,1.28.98,1.14,3.21,2.82,3.21,1.24-.26,1.94,2.31,1.58,4.12-.42,1.54-2.04,1.3-2.96.68-1.14-.68-3.82-1.23-5.54-4.29,1.16.9-4.18.79-5.71.58-1.53.19-3.25,1.06-4.67-.09-1.43-1.22-.66-3.8.99-3.71,1.28-.71,4.42-1.24,5.57.21"
          />
          <path
            id="path6189"
            className="cls-41"
            d="M111.86,49.98c1.04.7,1.65,2.06,2.17,3.32,1.09,1.74,2.93,2.24,4.44,3.22,1.29.38,1.81,1.85,2.32,3.19.98,2.24,2.69,3.73,4.34,5.14.78,1.28,2.22,1.21,3.37.92,1.33-.27,1.15-2.36,1.98-3.33.83-1.03,2.85-1.89,1.8-3.72-1.08-1.53-.59-3.44.66-4.51.96-1.34-.06-3.24.75-4.71.75-1.49.14-3.22-.69-4.42-.93-1.21-2.83-1.5-3.94-.43-1.04,1.64.57,3.35,1.08,4.82.78,1.68-.36,3.05-.96,4.33.22,1.47.57,3.34-1.04,3.77-1.59.47-2.68,2.02-2.53,4.1-.31,1.7-2,1.72-2.93,2.67-.55,1.18-.01,2.97-1.26,3.81-.88,1.13-1.86,2.27-3.17,2.48-1.81.34-3.63-.13-5.43-.31-1.74.12-1.55,3.72.16,3.79,1.46.92,3.32,2.06,4.88.82,1.02-1.2,2.43-.96,3.68-1.37,1.25-.77,2.15-2.3,2.65-3.91.33-2.01,2.7-1.44,3.07-3.42-.04-2.11-2.3-2.07-3.49-2.72l-.23-.14-.21-.2"
          />
          <path
            id="path6191"
            className="cls-42"
            d="M109.65,56.94c-.09,1.72.03,3.56.68,5.1.48,1.34-.45,2.75.02,4.06.77,1.28.84,2.84.47,4.32-.14,1.43-.28,2.86-.54,4.27-.18,1.15-1.26.88-1.96.95-1.33-.08-2.66.01-3.99-.04-1.15-.2-2.06-1.26-2.82-2.29-.47-1.39-2.11-1.03-2.51-2.44-.6-1.45-2.13-1.56-2.86-2.84-.92-1-.09-2.5.29-3.58.28-1.24,1.44-1.27,1.74-.03.49,1.3.59,3.06,1.79,3.71,1.07.32,1.6,1.37,2.01,2.5,1.12,1.16,2.67.56,3.99.89,1.05.16,1.87,1.31,2.99,1.07,1.29-.07,1.77-1.88,2.91-2.36,1.37-.68,2.74.4,4.13.28,1.25.06,1.81,2.31.38,2.68-1.01.69-2.59.11-3.01,1.81-.45,1.36-1.98,1.63-2.89.88-.86-.94-.33-2.5.08-3.57.12-.34.24-.69.28-1.07"
          />
          <path
            id="path6193"
            className="cls-43"
            d="M98.9,54.76c-.06-1.2-.96-1.56-2.18-1.95-.46-.14-1.21,1.95-1.32,2.23-.4,1.02-.2,2.86-.59,4.08-.53,1.68.06,2.04,1.18,2.04.94,0,.89-1.79,1.18,0,.18,1.12,1.26,1.34-.15,2.23-.75.47-1.76.37-2.35.74-.89.56.46,2.71.73,2.97.87.82.41,1.74,1.47,2.41,1.09.69,0,2.23,1.76,1.67.54-.17,1.53-1.61,2.2-2.04.9-.57,1.45.39,1.62.93.27.86,0,2.62.15,3.34.3,1.5,2.36.54,2.65-.19.58-1.47.67-1.85,2.06-1.85.81,0,1.51.21,2.35,0,.75-.19.95-.81,1.76-.56.92.29,1.21.74,2.2.74.47,0,.73,2.12.73,2.6,0,1.98,1.97.11,2.2-.19.69-.87,1.98-.09,2.65-.93.61-.77-.46-2.35-.59-3.15-.14-.88,1.37-.52,2.06-.74,1.39-.44,1.15-3.74,2.94-1.48,1.22,1.54,1.38,2.09,2.06.37.48-1.21,1.33-.4,1.62-1.85.3-1.5.59-1.77,1.47-2.6.7-.66-.47-1.79-.73-2.04-.95-.89-1.43-.53-2.06-1.85-.5-1.05.64-1.92.88-2.23.61-.77,1.19-.59,2.06-.37,1.11.28,1,2.23,2.5,2.23,1.25,0,1.34-1.75,1.18-2.6-.35-1.79.06-1.52-.88-2.41-.62-.58-1.79-1.04-2.5-1.48-.62-.39.54-2.65.59-2.97.22-1.37,1.6-.93,2.5-.74,1.09.23,1.53.78,2.06-.56.06-.14-.29-1.87-.15-2.6.25-1.24.24-1.7-.59-2.23-1.05-.66.68-2.48-.88-2.97-.79-.25-1.46-.37-2.35-.37-1.14,0-1.24.4-1.47-.74-.21-1.04.29-2.04.29-3.15,0-1.34,1.1-.93,2.06-.93,1.05,0,2.07.74,3.23.74.79,0-.5-1.98-.59-2.04-.91-.58-1.64-1.31-2.5-1.67-.86-.36-2.13-.65-2.65-1.3-.9-1.13-.36-2.47-.36-4.08,0-1.19-.82-1.96-.23-2.97.6-1.02,1.53-1.04,2.35-1.3.69-.22,1.02-.68,1.18-1.48.17-.86.41-2.85.28-3.7-.2-1.25-.56-1.57-1.47-1.85-1-.31-1.47.28-2.2.74-1.01.63-1.61-.54-2.06-1.11-.7-.88-.78-1.61-.15-2.41.54-.68.84-1.46,1.03-2.41.23-1.15-.52-1.95-.88-2.41-.34-.43-2.68-.64-2.94-.56-1.01.32-1.8,1.78-2.35,2.6-.41.61-2.83.23-3.22-.01-.67-.42-.44-2.33-.44-3.15,0-1.18.73-1.79.73-3.15s-4.04-1.87-4.26-1.3c-.46,1.16-.73,1.46-.73,3.15,0,1.18-.62,1.33-1.03,1.85-.41.52-1.58.11-1.91,0-.37-.12-1.11-1.26-1.47-1.48-.88-.55-1.15-1.24-1.91-1.48-.79-.25-1.67.12-2.06.37-.6.38-.59,1.63-.59,2.6,0,1.54,1.48,1.28.73,3.15-.3.77-1.24.74-1.91.74-.62,0-1.48-1.07-1.91-1.48-.96-.9-.49-1.11-1.91-1.11-.95,0-1.13,1.41-1.62,2.23-.73,1.23-.58,1.33-.29,2.23.07.24,1.72.83,1.91.93.48.24.09,3.64,0,4.08-.22,1.1-1.42,1.11-2.2,1.11-.87,0-1.68-.16-2.2,0-.86.27-.21,2.26,0,3.34.09.47,1.77.65,2.06.74.64.2,1.6.23,2.06.37"
          />
          <path
            id="path6195"
            className="cls-42"
            d="M112.45,41.37c1.35.02,1.75.47,2.73,1.7,1.15.77,2.42,1.28,3.68,1.68,2.25.32,4.22,2.2,6.54,1.92,1.13-.26,2.42.17,3.44-.52.66-1.03.39-2.36.1-3.49,0-1.38-.91-2.85-.17-4.17.8-1.12.74-2.68.73-4.08-.42-1.36-1.59-2.15-1.96-3.59-.6-1.49,1.73-2.12.84-3.73-.49-1.74.13-3.2.05-5.11.45-1.12,0-1.28.86-1.73,1.06-.33,2.08.23,3.06,1.48,1.48,1.89.66,6.18.88,7.27.19,1.33.14,2.78-.43,3.97-.61,1.45.27,2.95.92,4.1.71.94,1.21,2.55.24,3.52-.88.76-1.7,2.04-.57,3.11.9.88.71,3.08-.53,3.3-1.29.15-2.61.12-3.89-.09-.19-.08-.36-.23-.51-.41"
          />
          <g id="g6197">
            <path
              id="path6199"
              className="cls-49"
              d="M125.68,36.42c1.34-.37,2.73-.04,4.08-.33.76-.03,1.61.04,2.23-.61.27-.31,1.1-.08.97-.72-.15-.54-.7-.78-1.1-.55-.71.24-1.34.91-2.11.85"
            />
            <path
              id="path6201"
              className="cls-49"
              d="M125.82,37.34c.06-.44,3.93.11,5.46-.33.27-.12.82-.14.87-.54-.51-.26-1.06.05-1.59.03-.36.07-.97-.01-.94-.61.08-.33.4-.4.61-.56"
            />
            <path
              id="path6203"
              className="cls-49"
              d="M125.86,38.34c1.38,0,3.31-.1,4.68-.35.52-.02,1.06.05,1.55.29-.77.27-1.56.47-2.36.58-.21.18-.76-.86.66-1.13"
            />
            <path
              id="path6205"
              className="cls-49"
              d="M125.53,39.17c1.78.01,3.56-.02,5.34.01.41-.27.91.61.41.88-.58.46-1.29.19-1.93.21"
            />
            <path
              id="path6207"
              className="cls-49"
              d="M125.6,36.75c1.34-.37,2.73-.04,4.08-.33.76-.03,1.61.04,2.23-.61.27-.31,1.1-.08.97-.72-.15-.54-.7-.78-1.1-.55-.71.24-1.34.91-2.11.85"
            />
            <path
              id="path6209"
              className="cls-49"
              d="M125.63,35.74c1.34-.37,2.73-.04,4.08-.33.76-.03,1.61.04,2.23-.61.27-.31,1.1-.08.97-.72-.15-.54-.7-.78-1.1-.55-.71.24-1.34.91-2.11.85"
            />
            <path
              id="path6211"
              className="cls-49"
              d="M125.74,35.19c1.34-.37,2.73-.04,4.08-.33.76-.03,1.61.04,2.23-.61.27-.31,1.1-.08.97-.72-.15-.54-.7-.78-1.1-.55-.71.24-1.34.91-2.11.85"
            />
            <path
              id="path6213"
              className="cls-49"
              d="M125.6,34.59c1.34-.37,2.73-.04,4.08-.33.76-.03,1.61.04,2.23-.61.27-.31,1.1-.08.97-.72-.15-.54-.7-.78-1.1-.55-.71.24-1.34.91-2.11.85"
            />
            <path
              id="path6215"
              className="cls-49"
              d="M125.38,40.82c1.34-.37,2.73-.04,4.08-.33.76-.03,1.61.04,2.23-.61.27-.31,1.1-.08.97-.72-.15-.54-.7-.78-1.1-.55-.71.24-1.34.91-2.11.85"
            />
            <path
              id="path6217"
              className="cls-49"
              d="M125.67,40.13c1.34-.37,2.73-.04,4.08-.33.76-.03,1.61.04,2.23-.61.27-.31,1.1-.08.97-.72-.15-.54-.7-.78-1.1-.55-.71.24-1.34.91-2.11.85"
            />
            <path
              id="path6219"
              className="cls-49"
              d="M125.45,41.46c1.34-.37,2.62.83,3.97.54.76-.03,1.61.04,2.23-.61.27-.31,1.1-.08.97-.72-.15-.54-.7-.78-1.1-.55-.71.24-2.65.47-1.14-.02"
            />
            <path
              id="path6221"
              className="cls-49"
              d="M125.38,42.01c1.34-.37,2.51.65,3.86.35.76-.03,1.61.04,2.23-.61.27-.31,1.1-.08.97-.72-.15-.54-.7-.78-1.1-.55-.71.24-2.35.98-1.23.09"
            />
            <path
              id="path6223"
              className="cls-49"
              d="M126,37.8c1.34-.37,2.73-.04,4.08-.33.76-.03,1.35.36,1.97-.29.27-.31,1.1-.08.97-.72-.15-.54-.7-.78-1.1-.55-.71.24-2.65.66-1.56-.04"
            />
            <path
              id="path6225"
              className="cls-49"
              d="M125.22,42.22c1.37.08,2.57.52,3.94.67.74.21,1.55.56,2.28.13.33-.21,1.08.27,1.09-.39-.03-.57-.51-.97-.95-.89-.74,0-2.33.42-1.02-.18"
            />
          </g>
          <path
            id="path6227"
            className="cls-22"
            d="M110.24,32.67c-.16.2-.63.6-.81.82-.21.27-.22.66-.22,1.1,0,.47.15.9.15,1.37,0,.74-.12,1.2.44,1.37.28.09.5.34.88.46.39.12.51-.64.66-1.01.13-.32.07-.92.07-1.37,0-.59.07-1.07.07-1.65,0-.61-.47-.58-.73-.92-.13-.16-.33-.14-.51-.18Z"
          />
          <g id="text6229" className="cls-50">
            <text
              className="cls-51"
              transform="translate(107.27 79.4) rotate(20.77) scale(.83 .99) skewX(8.38)"
            >
              <tspan x={0} y={0}>
                {"PioM"}
              </tspan>
            </text>
          </g>
          <path
            id="path6233"
            className="cls-39"
            d="M104.2,29.51c-.26-.94-.56-2.03-2.02-2.39-1.02-.26-2.05-1.11-2.94-1.47-1.31-.52-2.27-1.32-3.68-2.02-1.35-.68-2.44-2.3-1.84-3.5.57-1.13,4.82-3.69,4.42-4.23-1.04-1.38-2.22-2.92-1.47-4.42,1.28-2.57,4.27.71,4.6,1.29,1.02,1.79-1.94,1.4-2.94,1.66-.3.08-.61.12-.92.18-.48.1-.98.12-1.47.18-.97.12-.92,3.32-.74,4.05.39,1.58,2.39,1.54,2.39,3.68,0,1.09-1.18,2.37-1.79,3.13-.53.66-.28,1-.18,1.47"
          />
          <path
            id="path6235"
            className="cls-5"
            d="M98.86,28.4c-.2.19.26.79.32.82.63.21.51-.58.48-.69-.06-.13-.2-.22-.34-.25-.02,0-.43.03-.46.12Z"
          />
          <path
            id="path6237"
            className="cls-46"
            d="M115.46,10.68c-.08-2.25-2.74-2.57-4.01-2.61-2.81.12-4.82.84-7.79,3.58-1.22,1.23-2.08,2.79-3.31,3.98-1.46,1.71-2.42,4.2-2.3,6.71.65,1.96,1.48,3.8,1.9,5.88.11.43.15.89.08,1.33-.02.12.02.31-.07.37-.38.24-.82.4-1.25.18-.31-.15-1.13-.5-1.32-.82-.24-.4-.43-.86-.81-1.1-.4-.25-.87-.53-1.25-1.01-.37-.47-.15-1.03-.15-1.65,0-.48.31-.97.07-1.56-.11-.29-.45-.88-.51-1.19-.09-.42-.29-1.01-.07-1.56.16-.39.37-.8.37-1.28,0-.55-.15-.78-.15-1.37,0-.68.02-1.22.37-1.65.13-.16.98-.87,1.03-1.1.11-.53.1-1.08.22-1.47.05-.15.1-.31.15-.46.19-.58.48-1.33,1.03-1.56.38-.16.69-.43,1.18-.73.49-.3.65-.47.96-1.1.35-.73.72-1.14,1.4-1.56.53-.33,1.24-.4,1.76-.73.32-.2.69-.54.88-1.01.16-.41.25-.62.66-.82.47-.23.83-.76,1.32-.92.39-.12.78-.24,1.18-.37.37-.11.84-.57,1.25-.82.27-.17.86-.82,1.18-.92.58-.18,1.01,0,1.54,0,.57,0,1.08.2,1.54-.09.32-.2.78-.62,1.4-.37.35.15.88.27,1.1.55.27.34.71.58.88,1.01.19.48.37.82.51,1.19.21.52.15.76.15,1.37,0,.32-.08,1.38-.22,1.74-.14.34-.33,1.24-.59,1.56-.1.12-.2.24-.29.37Z"
          />
          <path
            id="path6239"
            className="cls-34"
            d="M102.74,59.75l-4.38,3.8c1.28,4.01,6.29,7.16,7.22,6.71l.66-8.19-1.65,7.65,1.21-7.96-1.94,7.27,1.52-7.81-2.51,7.24,2.01-7.54-2.99,6.5,2.56-6.83-3.51,6.16,3.2-6.63-3.98,6.02,3.62-6.11-4.12,5.31,3.67-5.59-4.24,4.42,3.67-4.43Z"
          />
          <path
            id="path6241"
            className="cls-34"
            d="M113.43,61.8l.72,6.9c4,1.45,6.12-2.85,8.23-5.17l-5.7-4.01,4.59,4.78-5.04-4.33,4.33,5.01-4.98-4.81,4.16,5.53-4.88-5.4,3.97,5.92-4.16-5.37,3.51,6.24-3.87-5.89,2.8,6.5-3.09-6.37,2.11,6.67-2.44-6.5,1.5,6.57-1.76-6.28Z"
          />
          <path
            id="path6243"
            className="cls-13"
            d="M109.12,51.74c-.61.24-1.88.17-2.69.41-.41.02-.76,1.2-.51,1.42.44.4,1.13.59,1.8.61.36.01,1.74-.31,2.14-.31,1.02,0,1.22-1.03.97-1.34-.31-.37-1.06-.88-1.71-.77Z"
          />
          <path
            id="path6245"
            className="cls-13"
            d="M108.91,52c-.47.2-1.44.15-2.07.35-.32.02-.58,1.02-.39,1.21.34.34.87.5,1.38.52.28.01,1.34-.26,1.65-.26.79,0,.94-.88.74-1.15-.24-.31-.82-.75-1.32-.66Z"
          />
          <path
            id="path6247"
            className="cls-13"
            d="M108.66,52.53c-.35.15-1.08.11-1.55.25-.24.01-.44.74-.29.87.25.25.65.36,1.04.37.21,0,1-.19,1.24-.19.59,0,.7-.63.56-.82-.18-.23-.61-.54-.99-.48Z"
          />
          <path
            id="path6249"
            className="cls-13"
            d="M108.71,52.82c-.28.11-.87.08-1.24.19-.19,0-.35.58-.24.68.2.19.52.28.83.29.17,0,.8-.15.99-.15.47,0,.56-.5.45-.65-.15-.18-.49-.42-.79-.37Z"
          />
          <path
            id="path6251"
            className="cls-13"
            d="M108.7,53c-.18.09-.57.07-.82.16-.13,0-.23.47-.15.55.13.16.34.23.55.24.11,0,.53-.12.65-.12.31,0,.37-.4.29-.53-.1-.14-.32-.34-.52-.3Z"
          />
        </g>
        <path
          id="path4921"
          className="cls-20"
          d="M48.2,84.82c.32,3.58-22.37,27.84-24.76,51.36-.83,8.17,9.61,35.18,11.41,43.2.75,3.34,6.89,8.36,7.2,11.77.11,1.16-1.51,1.67-1.16,2.12,7.73,9.84-7.09-8.36-7.89-12.48-3.15-16.06-13.41-31.81-11.96-46,1.69-16.46,24.41-49.46,24.41-49.46,0,0,2.63-1.87,2.75-.5Z"
        />
        <g id="g6254">
          <path
            id="path6256"
            className="cls-8"
            d="M43.12,51.5c.08-.02,2.12-1,1.43-1.01-.69-.02-2.69-.72-2.81-.78-.11-.06-1.04.61-.85.8.2.2,2.15,1.01,2.23.99Z"
          />
          <path
            id="path6258"
            className="cls-36"
            d="M44.27,50.58c-.27.03-.45,0-.79.46-.09.18-.53-.51-1.63-.7.22-.19,2.32.19,2.42.24Z"
          />
          <path
            id="path6260"
            className="cls-37"
            d="M45.22,39.33c-.38-13.58-10.81-19.56-18.32-20.23C1.91,18.88-.03,48.45.13,64.07c.26,24.45,12.57,34.45,23.71,35.85,5.15.4,20.53-4.09,20.11-19.94-2.18-14.1-9.67-14.29-11.45-17.35-4.11-20.63,13.36-.52,12.72-23.29Z"
          />
          <path
            id="path6262"
            className="cls-10"
            d="M44,38.81c.02-7.97-7.13-19.16-17.95-19.46C1.06,19.14.15,46.17.38,58.55c.46,25.58,8.56,35.69,23.12,37.59,3.31.95,20.75,0,19.97-17.51-2.18-13.93-10.4-13.76-12.19-16.79-4.11-20.39,13.21-.51,12.72-23.03Z"
          />
          <path
            id="path6264"
            className="cls-41"
            d="M23.6,46.26c-1.03-.48-1.13-1.48-1.72-2.54-.31-1.06-.89-1.91-1.56-2.65-.85-.98-1.38-2.27-1.74-3.62-.98-2.37-.72-5.3-2.04-7.49-.51-1.24-1.59-1.8-2.68-1.6-1.33-.08-3.47-.32-3.9.93-.38,1.52-3.04,6.14-3.92,6.68-.87.94-.61,2.57-.44,3.98.37,1.4-.37,2.42-1.13,3.31-.53,1.06-1.06,2.27-.83,3.57.23,1.14-.02,2.26-.5,3.24-.49,1.2-.39,2.97.75,3.53,1.14.61,2.43.35,3.63.32,1.25-.34,1.26-2.43,1.03-3.68-.15-1.28-.9-2.62-.47-3.92.69-.75.56-.94.05-2.37-.99-.22-1-2.61-.24-3.83.66-1.03,1.19-4.69,1.74-5.84,1-1.07,2.55-.95,3.56-2.03.81-.98,3.56,1.58,4.59,1.6"
          />
          <path
            id="path6266"
            className="cls-48"
            d="M18.14,35.54c.09-2.16-.13-4.31-.48-6.43-.13-1.83,1.11-3.31,1.56-5.01.33-1.59,1.74-2.53,3.29-2.7,1.32-.65,3.47-.06,3.57,1.6-.63,1.29-2.53,3-3.74,3.65-1.49.52-3-.97-4.52-1.18-1.21-.44-1.69-2.67-3.23-1.5-1.25.63-2.44,1.53-2.31,3.1-.38,1.53-6.45,4.83-5.92,6.6-.15,1.9,1.2,3.96.35,5.74-.75,1.32-3.44.42-2.51-1.1.82-1.29,2.59-.59,3.79-1.2,1.14-.57,2.02-1.69,2.33-2.93"
          />
          <path
            id="path6268"
            className="cls-44"
            d="M25.44,66.23c-.87,1.35-1.05,3.23-2.13,4.41-.97,1.14-1.79,2.5-2.9,3.43-1.22.64-1.94,1.93-2.69,3.2-1.02,1.3-2.66,1.63-3.5,3.17-.51,1.52-2,1.51-2.95,2.37-.8.63-1.84,1.45-1.93,2.71.38,1.17,1.58,1.31,2.45,1.58,1.21.02,1.89,1.21,2.7,2.09.86,1.04,1.7,2.17,2.87,2.67,1.29.74,2.72,1.16,4.14.91,1.32.07,2.44,1.52,3.81,1.02,1.19,0,2.62-.64,2.71-2.36.31-1.51-1.07-1.87-1.97-1.71-1.63-.02-3.25.82-4.86.2-1-.26-1.93-.88-2.92-1.14-1.2.4-1.83-.72-2.53-1.62-.97-.97-1.24-2.56-2.11-3.63-.5-.67-.3-1.44-.1-2.18"
          />
          <path
            id="path6270"
            className="cls-44"
            d="M27.13,74.74c.52.37.06,1.62.22,2.31-.14,1.26.48,2.28.67,3.45.21,1.56-.18,3.1-.43,4.61-.07,1.2.27,2.52-.3,3.6-.43.98-1.21,2.03-.88,3.23.23,1.07,1.01,1.83,1.89,1.87.88.16,1.73-.26,2.55-.57,1-.24,2.02-.36,3-.67.9-.42,1.96.3,2.72-.47.98-.86,1.8-1.96,2.71-2.92.7-.93,1.04-2.38.55-3.56-.65-1.19-1.89-.54-2.46.4-.81.84-1.75,1.48-2.4,2.54-.83,1.35-2.27,1.53-3.49,1.95-.92.18-1.89-.27-2.78.2-.72.07-1.65-1.18-1.42-2.05"
          />
          <path
            id="path6272"
            className="cls-41"
            d="M32.12,67.14c1.23,1.42,1.71,3.71,1.3,5.72-.07,1.74,1.22,2.88,1.69,4.41,1.03,1.56,2.94,1.94,4.39,1.13,1.23-.92,2.97.12,2.77,2.03,0,1.34-1.23,1.98-1.28,3.32-.06,1.42-.41,3.27-1.71,3.62-1.25-.22-.66-2.29-.61-3.33.1-1.55,1.33-2.46,1.39-4,.14-1.44-.41-2.9-1.31-3.79-.93-1.42-.95-3.41-.76-5.12.77-1.22,1.48.41,1.73,1.28.61,1.56,1.22,3.12,1.77,4.71.41,1.17.04,3.7-1.31,3.18-.59-.38-.75-1.73-1.6-1.44"
          />
          <path
            id="path6274"
            className="cls-15"
            d="M45.94,55.14c-1.54-.35-7.42-.82-8.85-1.31-1.39-.52-2.36-1.89-3.14-3.34-.84-1.4-6.44-10.04-4.65-20.52-.19-.67-.51-1.35-.88-.42.5,1.47-1.57,6.73,2.72,18.57,2,3.06,4.57,7.6,2.84,8-2.19,1.32-6.17,6.49-6.88,7.92-1.27,1.85-2.22,4.02-3.02,6.22,1.19-.74,1.84-2.8,2.78-4.1.84-1.48,8.55-10.4,8.28-8.47-1.28,1.35-2.21,3.42-2.99,5.2-.67,2.19-1.3,8.61-.1,7.61.21-.47.01-2.89.29-3.82.47-1.67.75-3.6,1.73-5.01.93-1.64,2.3-1.35,3.84-1.81,1.87-.31,5.79.48,7.64-.08,2.42-.53,1.88-4.58.38-4.64Z"
          />
          <path
            id="path6276"
            className="cls-44"
            d="M30.58,67.42c.33-.86.85.7,1.06,1.08.5,1.1.91,2.28,1.17,3.51.48.91.77,2.01,1.48,2.69.44.61.8,1.37,1.47,1.61.95.6,2.01.99,3.08.8.79.02,1.56-.15,2.12-.91.63-.73.53-2.08.06-2.9-.59-.61-1.45-1.03-1.55-2.14-.39-.76-.51-1.89-1.16-2.35-1.08-.28-1.17,1.43-1.13,2.36.07.94.38,1.82.7,2.66.44.86,1.04,1.6,1.33,2.58.5.87.93,1.85.86,2.97.06,1.2-.47,2.23-.83,3.29-.28.79-.73,1.46-1.2,2.08-.48,1.17.61,2.1,1.46,2.05.85.2,1.94.04,2.14-1.23.3-.86.49-1.75.48-2.7.06-1.57-.03-3.13,0-4.7,0-.97-.3-2.27-1.21-2.41-.66-.1-1.13.76-1.44,1.35"
          />
          <path
            id="path6278"
            className="cls-31"
            d="M32.12,71.16c.86-.58,3.34-1.64,3.87-1.7,1.25.48,1.41,6.71.35,7.36-1.41.28-2.57-1.76-4.52-1.97-.18-.54-.53-2.68.3-3.69Z"
          />
          <path
            id="path6280"
            className="cls-16"
            d="M17.8,73.06c-1.5.53-4.38,3.85-5.1,4.26-2.07.11-4.2-4.92-4.61-7.11-.1-.86.37-2.56.08-3.44-.78-2.27,7.14-.14,8.1.89.59.65,1.57,4.87,1.53,5.4Z"
          />
          <path
            id="path6282"
            className="cls-11"
            d="M17.27,61.27c-1.52.21-4.85,2.69-5.61,2.95-2-.32-3.19-5.7-3.22-7.94.05-.87.79-2.44.65-3.36-.36-2.39,6.87.52,7.62,1.72.45.76.69,6.11.56,6.63Z"
          />
          <path
            id="path6284"
            className="cls-34"
            d="M17.32,60.26l-6.04,3.47c-2.98-3.02-2.27-8.34-1.51-11.57l7.52,2.92-6.91-1.46,7.08,2.1-7.22-.78,7.45,1.55-7.69-.15,7.91.76-7.95.44,7.97.24-8.04,1.17,7.9-.77-7.65,2.14,7.42-1.59-7.13,2.77,7.07-2.04-6.61,3.02,6.42-2.22Z"
          />
          <path
            id="path6286"
            className="cls-26"
            d="M16.43,49.42c-1.4-1-5.79-1.3-6.57-1.67-1.48-1.81.21-8.24,1.54-10.17.56-.7.75-.55,1.19-1.44,1.14-2.32,6.86,6.46,6.76,8.06-.08.99-2.5,4.88-2.92,5.22Z"
          />
          <path
            id="path6288"
            className="cls-34"
            d="M16.53,48.76l-6.72-1.35c-1.28-4.05,1.36-9,3.51-11.53l5.42,7.04-5.96-5.42,6.31,6.26-7.13-5.12,7.2,5.92-7.82-4.68,7.88,5.53-8.5-4.41,8.15,5.01-8.66-3.65,8.29,4.35-8.72-3.02,8.28,3.84-8.3-2.59,7.7,3.12-7.61-1.64,6.67,2.34Z"
          />
          <path
            id="path6290"
            className="cls-1"
            d="M23.42,41.72c-.46-2.04-3.31-5.95-3.66-6.93-.12-2.83,4.13-5.8,5.99-6.4.73-.15,2.18.48,2.92.06,1.92-1.09.18,9.77-.68,11.1-.54.81-4.11,2.21-4.57,2.16Z"
          />
          <path
            id="path6292"
            className="cls-34"
            d="M23.92,40.88l-4.08-6.45c2.94-4.59,6.22-6.24,9.3-5.53l-.67,10.45-.35-9.96.14,10-1.37-9.77.87,10.05-2.01-9.74,1.54,10.2-2.97-9.75,2.45,9.76-3.41-8.54,2.78,8.93-3.85-8.25,3.06,8.23-3.95-7.57,3.28,7.68-3.94-6.96,3.18,7.2Z"
          />
          <path
            id="path6294"
            className="cls-7"
            d="M28.34,39.06c.89-1.31,1.71-5.89,2.08-6.65,1.46-1.26,4.93,2.01,6.08,3.73.4.71.71,2.49,1.26,3.1,1.43,1.58-5.14,4.13-6.24,3.76-.67-.25-3.01-3.44-3.18-3.94Z"
          />
          <path
            id="path6296"
            className="cls-34"
            d="M28.9,40.59l1.89-8.06c3.6-.52,5.8,4.92,6.99,7.4l-6,3.13,5.28-4.04-5.22,3.38,4.58-4.27-5.17,4.15,4.78-5.02-5.44,4.76,4.83-5.73-5,5.35,4.39-6.3-4.68,5.94,3.87-6.65-4.48,7.06,3.32-7.72-3.41,6.77,2.49-7.34-3.01,7.18Z"
          />
          <path
            id="path6298"
            className="cls-32"
            d="M29.08,76.58c.38,1.12.99,4.3.98,4.96-.5,1.51-5.5,1.09-5.91-.28-.09-1.77,1.65-3.02,2.02-5.42.45-.17,2.2-.4,2.92.74Z"
          />
          <path
            id="path6300"
            className="cls-33"
            d="M31.86,43.88c.89-.51,3.41-1.38,3.94-1.4,1.23.57,1.07,6.81-.01,7.38-1.42.18-2.48-1.95-4.42-2.32-.15-.56-.4-2.72.49-3.66Z"
          />
          <path
            id="path6302"
            className="cls-30"
            d="M21.67,55c-.93.39-3.51.93-4.04.88-1.17-.73-.49-6.91.63-7.33,1.42.01,2.3,2.27,4.2,2.88.11.57.17,2.76-.79,3.58Z"
          />
          <path
            id="path6304"
            className="cls-9"
            d="M47.74,81.89c-.06.88.45,2.2.45,2.99,0,.41-1.65.31-2.07-.13-.22-.24-.05-2.18.07-2.67.12-.48,1.22-.36,1.55-.19Z"
          />
          <path
            id="path6306"
            className="cls-45"
            d="M23.89,45.33c-1.21-.42-2.75-2.12-3.35-3.76-.36-.88-3.8-3.98-4.08-4.96-1-2.08-2.31-4.19-2.18-6.59,0-1.72.49-5.35.55-5.43"
          />
          <path
            id="path6308"
            className="cls-34"
            d="M17.1,72.07l-4.58,4.93c-3.63-2.2-3.86-7.62-3.91-10.95l6.88,1.61-6.31-.25,6.64.83-6.45.48,6.9.06-6.78,1.35,7.19-.62-6.94,1.8,6.81-1.33-6.54,2.71,6.52-2.17-5.95,3.43,6.81-3.35-6.24,4.43,5.61-3.51-4.92,4.35,5.26-3.82Z"
          />
          <path
            id="path6310"
            className="cls-17"
            d="M48.19,85.06c-.51-4.98-1.44-22.08-13.24-33.09-2.28-1.79-4.59-3.69-1.08-9.15-2.46.3-4.27-2.33-4.74-5.84-1.18,4.96-8.14,1.1-6.58,3.48,1.3,1.6,1.85,7.49.17,5.9-1.45-.64-2.54-5.43-3.89-3.7-.2,1.91-1.62,4.9-3.21,6.29-.3,2.79,5,1.76,6.04,3.45-.28,2.03-4.77.55-6.07,1.19,2.2,4.02,1.16,5.88.81,9.37,1.17-1.11,8.51-5.63,7.96-2.37-.58,2.62-2.98,3.25-4.81,3.91-1.31.55-4.47.11-4.67,2.23,1.67,2.09,1.96,5.16,1.35,7.99,2.15.54,5.25-3.75,6.37-5.58.68-2.41,4.09-1.63,2.83,1.08-1.34,2.07-1.61,3.05-3.45,4.78-1.9,1.45-4.1,3.81-2.94,4.47.76.76,2.86.92,4.29,2.97.75,1.07,1.77-3.32,2.76-4.74,1-2.11,1.17-2.5,2.07-.35.55,1.88,1.65,3.89,2.32,5.37,1.75-3.14,7.23-2.03,3.8-4.72-1.79-2.21-2.6-5.48-3.05-9.03.24-1.86,1.49-3,2.75-3.91,8.44-6.08,11.81,17.82,11.25,20.64.22-1.07,2.99-2.67,2.97-.65Z"
          />
          <path
            id="path6312"
            className="cls-12"
            d="M34.99,79.23c-.19.89-2.65.9-4.48,2.57-.66-.62-2.05-5-2.77-5.96-.78-.74-1.55.31-1.68,1.25-.5.94-1.06,1.83-1.47,2.85-.35.8-.83,2.38-1.75,1.52-.42-1.24-3.48-1.76-3.35-2.72.45-1.41,5.77-5.68,6.76-9.59.21-.9,1.01-1.12,1.66-1.18.95-.1,1.88.39,2.62,1.09.58.65.64,1.67.73,2.57.49,2.17.97,4.47,2.19,6.2.48.53,1.14.76,1.54,1.4Z"
          />
          <path
            id="path6314"
            className="cls-1"
            d="M24.08,80.97c-1.16,1.34-.62,5.77-.87,6.6-1.3,1.59-5.31.49-6.82-1.95-.53-.57-1.33-1.89-1.99-2.32-1.72-1.13,4.3-3.86,5.58-5.18.18.01.84-.05.93.29.39.01.61-.04.76.47.14.04,1.03.03.78.49.65.11,1,.24,1.02.97.61.16.55.52.61.63Z"
          />
          <path
            id="path6316"
            className="cls-6"
            d="M34.13,78.39c1.18.73,3.97,3.35,4.4,4.06.38,2.22-5.88,7.88-7.27,6.94-1.26-1.77.27-5.33-1.1-8.22.05-.09-.08-.36.23-.34.1-.13.05-.38.35-.45.13-.16.11-.43.45-.5.24-.14.13-.4.52-.5.05-.24.17-.53.58-.45.31-.12.11-.42.61-.35.08-.18.24-.36.62-.2.17-.17.41-.04.61,0Z"
          />
          <path
            id="path6318"
            className="cls-47"
            d="M26.02,56.79c.48-.17,3.75.08,4.23,1.33"
          />
          <path
            id="path6320"
            className="cls-47"
            d="M26.21,51.71c.5-.03,2.78-.47,3.2-1.56"
          />
          <path
            id="path6322"
            className="cls-23"
            d="M26.69,61.1c.26.03.77.39,1.03.55.44.27.48.32.73.64.31.39.2.57.73.73.36.11.2.75.15,1.01-.08.38-.82.48-1.1.55-.55.14-.6-.28-.88-.46-.22-.14-.35-.77-.44-1.01-.1-.26-.54-.43-.73-.55-.51-.32-.29-1.01,0-1.37.13-.16.38-.09.51-.09Z"
          />
          <path
            id="path6324"
            className="cls-47"
            d="M26.13,61.28c.11-.14.78-1.65.77-2.66"
          />
          <path
            id="path6326"
            className="cls-38"
            d="M29.29,64.15c.16-.26,1.3-1.27,2.46-1.31"
          />
          <path
            id="path6328"
            className="cls-2"
            d="M48.09,85.17c-.02-4.96-3.46-25.33-13.06-30.57-1.47-1.05-3.11-2.01-4.17-3.71-.76-1.78-.41-3.96.38-5.62-2.64,1.69-1.44-3.3-3.12.85-.27-6.42-1.46-1.09-2.7-2.99,1.91,3.77-2.74,8.48.82,5.19,1.47-1.52,8.1,6.09,6.33,7-4.43-2.75-4.21-.72-3.83.9,1.25.18,3.01,1.4,1.93,3.26-1.14,2.83-2.34,1.91-.85,3.17,1.02-.03,4.9-2.86,2.7.52-1.02,1.66.84,1.48,1.44.47,1.53-1.35,3.59-2.58,5.42-1.29,4.98,3.5,6.12,13.63,5.9,24.61.21-.35,1.94-1.67,2.81-1.8Z"
          />
          <path
            id="path6330"
            className="cls-44"
            d="M32.27,57.98c-6.27,3.01-5.01-2.56-10.4,2.79-1.04-.09-6.8,4.1-9.08,3.9-.99-.07-2.21.51-3.01-.45-.4-.95-1.1-1.66-1.35-2.71-.35-1.06-.73-2.15-.64-3.32-.07-1.32.19-2.72-.25-3.97-.17-1.27,1.4-1.86,1.06-3.3-.19-1.27.16-3.01-.94-3.75-1-.73-2.13-.23-3.17.02-1.2-.49-1.97.87-1.63,2.24-.02,1.41.31,2.91-.29,4.21-.58,1.19.22,2.38.42,3.55.52,1.26-.75,2.24-.46,3.54.3,1.12,1.36,2.12.93,3.4-.77,1.2.14,2.3,1.17,2.27.95-.2,1.65-1.35,2.69-1.14.91.28,1.83.15,2.67-.34.49-.11.99,0,1.47-.15"
          />
          <path
            id="path6332"
            className="cls-2"
            d="M16.11,66.36c-.36.14-.51.76-.03.86,2.12,2.73.61,7.65,2.18,6.13,3.96-2.79,2.62-4.97,5.36-6.43.24-.2.28-1.05-.26-1.02-5.22,5.98-4.83,1.68-7.24.46Z"
          />
          <path
            id="path6334"
            className="cls-2"
            d="M17.51,61.37c1.57-2.94-1.27-7.68-.01-6.69,3.32,4.4,7.36,2.09,6.82,3.28-.98,1.7-3.71.04-6.8,3.4Z"
          />
          <path
            id="path6336"
            className="cls-2"
            d="M16.32,49.21c2.73-.97,3.03-6.87,3.47-5.09.23,6.03,4.51,7.54,3.47,8.01-1.63.5-2.84-2.97-6.95-2.92Z"
          />
          <path
            id="path6338"
            className="cls-25"
            d="M45.9,55.51c.96.48.92,2.23-.17,3.46-1.09,1.03.27-1.48-2.5-2.32-.89-.13-4.2-.4-4.32-1.19,3.67.21,6.26-.02,6.99.04Z"
          />
          <path
            id="path6340"
            className="cls-8"
            d="M48.08,48.07c-2.13,1.54-7.07,5.07-9.04,5.15-.37.01-4.71,1.19-5.62-5.22-1.12-2.64-.1,3.47.38,3.8.25.59-2.5-1.33-3.29-2.25-6.03-5.59-10.16-12.37-9-18.86-.1-.67.11-2.29-.51-1.17-2.5,6.5,3.67,16.79,10.69,21.96,1.2.95,2.57,1.47,3.85,2.23.53.14,1.66.68.68,1.14-.88.55-4.39,2.69-5.34,4.42.37.21.64.5,3.06-1.33,1.37-1.04,3.34-1.75,5-1.96,1.86-.24,7.82-3.21,10.33-5.06,1.41-1.03.67-4.19-1.19-2.84Z"
          />
          <path
            id="path6342"
            className="cls-14"
            d="M48.97,50.36c-1.75-1.17-7.78,3.68-9.9,3.78-1.35.06-4.13,2.32-3.37,1.51,1.81-1.92,2.42-1.46-.75-2.82-.48-.21-.83-1.2-.15-.49,1.32.95,2.87,1.4,4.38,1.16,2.22-.25,6.68-3.7,9.08-5.26,1.69-.73,1.71,2.79.7,2.12Z"
          />
          <path
            id="path6344"
            className="cls-44"
            d="M21.25,29.31c-.02-2.75-2.92-8.9-5.32-5.45-2.04,1.3-4.54,2.04-6.02,4.21-.91,4.34-3.98,5.72-4.92,8.66-1.31,3.53-2.71,6.67-1.56,11.39,1.95.39,2.37.39,5.18-2.56.28-3.85-.12-8.7,2.23-11.25,1.24-2.93,5.58-3.01,7.62-4.61.58-.68,1.97-.48,2.79-.38Z"
          />
          <path
            id="path6346"
            className="cls-44"
            d="M12.28,64.67c.33-.04,1.39.05.56.09-1.77.06-3.55.27-5.32.12-.82-.36-1.7-.93-2.58-.44-.86.49-1.3,1.6-1.92,2.43-.65.79-.3,1.94.07,2.79.64.98-.02,2.2.27,3.27.58.99,1.19,2.09,1.2,3.36.09,1.07,1.02,1.58,1.14,2.63.3,1.27.91,2.67,2.02,3.02.92.1.96,1.51,1.47,2.21.46,1.12,1.69,1.62,2.56.91,1.08-.67,1.4-2.43.93-3.75-.39-1-.74-2.18-1.68-2.58-.77-.54-.81-2.05-1.68-2.54-.41-.89-.79-1.81-1.45-2.46-.61-1.01-.41-2.34-.58-3.51-.27-.9-.54-1.83-.47-2.81.09-1.01.79-1.73,1.49-2.09"
          />
          <path
            id="path6348"
            className="cls-40"
            d="M29.35,27.83c1.63-.41.64-2.23,2.06-2.99,1.5-.53,3.49-.29,4.28,1.69.93,1.85,2.91,2.07,3.83,3.95.88,1.44,1.48,3.14,2.48,4.45-.03,1.66-.42,3.44.77,4.61.22,1.87.08,4.06-.6,5.73-1.06,1.01-3.07,3.27-4.2,1.46-.76-2.07,1.13-3.42,1.58-5.19-1.27-2.08-1.38-4.56-1.37-7.08-2.35-.99-2.62-3.05-4.21-3.69-1.54-.93-2.18-2.65-3.92-2.51-1.87-.59-.91-1.9-.88-3.25-.16-2.37-2.21-3.84-3.92-3.4-1.97.27-5.59.28-7.43,1.14-1.28.98-1.14,3.21-2.82,3.21-1.24-.26-1.94,2.31-1.58,4.12.42,1.54,2.04,1.3,2.96.68,1.14-.68,3.82-1.23,5.54-4.29-1.16.9,4.18.79,5.71.58,1.53.19,3.25,1.06,4.67-.09,1.43-1.22.66-3.8-.99-3.71-1.28-.71-4.42-1.24-5.57.21"
          />
          <path
            id="path6350"
            className="cls-41"
            d="M24.92,68.97c-1.04.7-1.65,2.06-2.17,3.32-1.09,1.74-2.93,2.24-4.44,3.22-1.29.38-1.81,1.85-2.32,3.19-.98,2.24-2.69,3.73-4.34,5.14-.78,1.28-2.22,1.21-3.37.92-1.33-.27-1.15-2.36-1.98-3.33-.83-1.03-2.85-1.89-1.8-3.72,1.08-1.53.59-3.44-.66-4.51-.96-1.34.06-3.24-.75-4.71-.75-1.49-.14-3.22.69-4.42.93-1.21,2.83-1.5,3.94-.43,1.04,1.64-.57,3.35-1.08,4.82-.78,1.68.36,3.05.96,4.33-.22,1.47-.57,3.34,1.04,3.77,1.59.47,2.68,2.02,2.53,4.1.31,1.7,2,1.72,2.93,2.67.55,1.18.01,2.97,1.26,3.81.88,1.13,1.86,2.27,3.17,2.48,1.81.34,3.63-.13,5.43-.31,1.74.12,1.55,3.72-.16,3.79-1.46.92-3.32,2.06-4.88.82-1.02-1.2-2.43-.96-3.68-1.37-1.25-.77-2.15-2.3-2.65-3.91-.33-2.01-2.7-1.44-3.07-3.42.04-2.11,2.3-2.07,3.49-2.72l.23-.14.21-.2"
          />
          <path
            id="path6352"
            className="cls-42"
            d="M27.13,75.94c.09,1.72-.03,3.56-.68,5.1-.48,1.34.45,2.75-.02,4.06-.77,1.28-.84,2.84-.47,4.32.14,1.43.28,2.86.54,4.27.18,1.15,1.26.88,1.96.95,1.33-.08,2.66.01,3.99-.04,1.15-.2,2.06-1.26,2.82-2.29.47-1.39,2.11-1.03,2.51-2.44.6-1.45,2.13-1.56,2.86-2.84.92-1,.09-2.5-.29-3.58-.28-1.24-1.44-1.27-1.74-.03-.49,1.3-.59,3.06-1.79,3.71-1.07.32-1.6,1.37-2.01,2.5-1.12,1.16-2.67.56-3.99.89-1.05.16-1.87,1.31-2.99,1.07-1.29-.07-1.77-1.88-2.91-2.36-1.37-.68-2.74.4-4.13.28-1.25.06-1.81,2.31-.38,2.68,1.01.69,2.59.11,3.01,1.81.45,1.36,1.98,1.63,2.89.88.86-.94.33-2.5-.08-3.57-.12-.34-.24-.69-.28-1.07"
          />
          <path
            id="path6354"
            className="cls-43"
            d="M37.88,73.76c.06-1.2.96-1.56,2.18-1.95.46-.14,1.21,1.95,1.32,2.23.4,1.02.2,2.86.59,4.08.53,1.68-.06,2.04-1.18,2.04-.94,0-.89-1.79-1.18,0-.18,1.12-1.26,1.34.15,2.23.75.47,1.76.37,2.35.74.89.56-.46,2.71-.73,2.97-.87.82-.41,1.74-1.47,2.41-1.09.69,0,2.23-1.76,1.67-.54-.17-1.53-1.61-2.2-2.04-.9-.57-1.45.39-1.62.93-.27.86,0,2.62-.15,3.34-.3,1.5-2.36.54-2.65-.19-.58-1.47-.67-1.85-2.06-1.85-.81,0-1.51.21-2.35,0-.75-.19-.95-.81-1.76-.56-.92.29-1.21.74-2.2.74-.47,0-.73,2.12-.73,2.6,0,1.98-1.97.11-2.2-.19-.69-.87-1.98-.09-2.65-.93-.61-.77.46-2.35.59-3.15.14-.88-1.37-.52-2.06-.74-1.39-.44-1.15-3.74-2.94-1.48-1.22,1.54-1.38,2.09-2.06.37-.48-1.21-1.33-.4-1.62-1.85-.3-1.5-.59-1.77-1.47-2.6-.7-.66.47-1.79.73-2.04.95-.89,1.43-.53,2.06-1.85.5-1.05-.64-1.92-.88-2.23-.61-.77-1.19-.59-2.06-.37-1.11.28-1,2.23-2.5,2.23-1.25,0-1.34-1.75-1.18-2.6.35-1.79-.06-1.52.88-2.41.62-.58,1.79-1.04,2.5-1.48.62-.39-.54-2.65-.59-2.97-.22-1.37-1.6-.93-2.5-.74-1.09.23-1.53.78-2.06-.56-.06-.14.29-1.87.15-2.6-.25-1.24-.24-1.7.59-2.23,1.05-.66-.68-2.48.88-2.97.79-.25,1.46-.37,2.35-.37,1.14,0,1.24.4,1.47-.74.21-1.04-.29-2.04-.29-3.15,0-1.34-1.1-.93-2.06-.93-1.05,0-2.07.74-3.23.74-.79,0,.5-1.98.59-2.04.91-.58,1.64-1.31,2.5-1.67.86-.36,2.13-.65,2.65-1.3.9-1.13.36-2.47.36-4.08,0-1.19.82-1.96.23-2.97-.6-1.02-1.53-1.04-2.35-1.3-.69-.22-1.02-.68-1.18-1.48-.17-.86-.41-2.85-.28-3.7.2-1.25.56-1.57,1.47-1.85,1-.31,1.47.28,2.2.74,1.01.63,1.61-.54,2.06-1.11.7-.88.78-1.61.15-2.41-.54-.68-.84-1.46-1.03-2.41-.23-1.15.52-1.95.88-2.41.34-.43,2.68-.64,2.94-.56,1.01.32,1.8,1.78,2.35,2.6.41.61,2.83.23,3.22-.01.67-.42.44-2.33.44-3.15,0-1.18-.73-1.79-.73-3.15s4.04-1.87,4.26-1.3c.46,1.16.73,1.46.73,3.15,0,1.18.62,1.33,1.03,1.85.41.52,1.58.11,1.91,0,.37-.12,1.11-1.26,1.47-1.48.88-.55,1.15-1.24,1.91-1.48.79-.25,1.67.12,2.06.37.6.38.59,1.63.59,2.6,0,1.54-1.48,1.28-.73,3.15.3.77,1.24.74,1.91.74.62,0,1.48-1.07,1.91-1.48.96-.9.49-1.11,1.91-1.11.95,0,1.13,1.41,1.62,2.23.73,1.23.58,1.33.29,2.23-.07.24-1.72.83-1.91.93-.48.24-.09,3.64,0,4.08.22,1.1,1.42,1.11,2.2,1.11.87,0,1.68-.16,2.2,0,.86.27.21,2.26,0,3.34-.09.47-1.77.65-2.06.74-.64.2-1.6.23-2.06.37"
          />
          <path
            id="path6356"
            className="cls-42"
            d="M24.33,60.36c-1.35.02-1.75.47-2.73,1.7-1.15.77-2.42,1.28-3.68,1.68-2.25.32-4.22,2.2-6.54,1.92-1.13-.26-2.42.17-3.44-.52-.66-1.03-.39-2.36-.1-3.49,0-1.38.91-2.85.17-4.17-.8-1.12-.74-2.68-.73-4.08.42-1.36,1.59-2.15,1.96-3.59.6-1.49-1.73-2.12-.84-3.73.49-1.74-.13-3.2-.05-5.11-.45-1.12,0-1.28-.86-1.73-1.06-.33-2.08.23-3.06,1.48-1.48,1.89-.66,6.18-.88,7.27-.19,1.33-.14,2.78.43,3.97.61,1.45-.27,2.95-.92,4.1-.71.94-1.21,2.55-.24,3.52.88.76,1.7,2.04.57,3.11-.9.88-.71,3.08.53,3.3,1.29.15,2.61.12,3.89-.09.19-.08.36-.23.51-.41"
          />
          <g id="g6358">
            <path
              id="path6360"
              className="cls-49"
              d="M11.11,55.42c-1.34-.37-2.73-.04-4.08-.33-.76-.03-1.61.04-2.23-.61-.27-.31-1.1-.08-.97-.72.15-.54.7-.78,1.1-.55.71.24,1.34.91,2.11.85"
            />
            <path
              id="path6362"
              className="cls-49"
              d="M10.96,56.33c-.06-.44-3.93.11-5.46-.33-.27-.12-.82-.14-.87-.54.51-.26,1.06.05,1.59.03.36.07.97-.01.94-.61-.08-.33-.4-.4-.61-.56"
            />
            <path
              id="path6364"
              className="cls-49"
              d="M10.92,57.34c-1.38,0-3.31-.1-4.68-.35-.52-.02-1.06.05-1.55.29.77.27,1.56.47,2.36.58.21.18.76-.86-.66-1.13"
            />
            <path
              id="path6366"
              className="cls-49"
              d="M11.25,58.17c-1.78.01-3.56-.02-5.34.01-.41-.27-.91.61-.41.88.58.46,1.29.19,1.93.21"
            />
            <path
              id="path6368"
              className="cls-49"
              d="M11.19,55.74c-1.34-.37-2.73-.04-4.08-.33-.76-.03-1.61.04-2.23-.61-.27-.31-1.1-.08-.97-.72.15-.54.7-.78,1.1-.55.71.24,1.34.91,2.11.85"
            />
            <path
              id="path6370"
              className="cls-49"
              d="M11.15,54.74c-1.34-.37-2.73-.04-4.08-.33-.76-.03-1.61.04-2.23-.61-.27-.31-1.1-.08-.97-.72.15-.54.7-.78,1.1-.55.71.24,1.34.91,2.11.85"
            />
            <path
              id="path6372"
              className="cls-49"
              d="M11.04,54.19c-1.34-.37-2.73-.04-4.08-.33-.76-.03-1.61.04-2.23-.61-.27-.31-1.1-.08-.97-.72.15-.54.7-.78,1.1-.55.71.24,1.34.91,2.11.85"
            />
            <path
              id="path6374"
              className="cls-49"
              d="M11.19,53.59c-1.34-.37-2.73-.04-4.08-.33-.76-.03-1.61.04-2.23-.61-.27-.31-1.1-.08-.97-.72.15-.54.7-.78,1.1-.55.71.24,1.34.91,2.11.85"
            />
            <path
              id="path6376"
              className="cls-49"
              d="M11.41,59.82c-1.34-.37-2.73-.04-4.08-.33-.76-.03-1.61.04-2.23-.61-.27-.31-1.1-.08-.97-.72.15-.54.7-.78,1.1-.55.71.24,1.34.91,2.11.85"
            />
            <path
              id="path6378"
              className="cls-49"
              d="M11.11,59.13c-1.34-.37-2.73-.04-4.08-.33-.76-.03-1.61.04-2.23-.61-.27-.31-1.1-.08-.97-.72.15-.54.7-.78,1.1-.55.71.24,1.34.91,2.11.85"
            />
            <path
              id="path6380"
              className="cls-49"
              d="M11.33,60.46c-1.34-.37-2.62.83-3.97.54-.76-.03-1.61.04-2.23-.61-.27-.31-1.1-.08-.97-.72.15-.54.7-.78,1.1-.55.71.24,2.65.47,1.14-.02"
            />
            <path
              id="path6382"
              className="cls-49"
              d="M11.41,61.01c-1.34-.37-2.51.65-3.86.35-.76-.03-1.61.04-2.23-.61-.27-.31-1.1-.08-.97-.72.15-.54.7-.78,1.1-.55.71.24,2.35.98,1.23.09"
            />
            <path
              id="path6384"
              className="cls-49"
              d="M10.78,56.8c-1.34-.37-2.73-.04-4.08-.33-.76-.03-1.35.36-1.97-.29-.27-.31-1.1-.08-.97-.72.15-.54.7-.78,1.1-.55.71.24,2.65.66,1.56-.04"
            />
            <path
              id="path6386"
              className="cls-49"
              d="M11.56,61.22c-1.37.08-2.57.52-3.94.67-.74.21-1.55.56-2.28.13-.33-.21-1.08.27-1.09-.39.03-.57.51-.97.95-.89.74,0,2.33.42,1.02-.18"
            />
          </g>
          <path
            id="path6388"
            className="cls-24"
            d="M26.54,51.66c.16.2.63.6.81.82.21.27.22.66.22,1.1,0,.47-.15.9-.15,1.37,0,.74.12,1.2-.44,1.37-.28.09-.5.34-.88.46-.39.12-.51-.64-.66-1.01-.13-.32-.07-.92-.07-1.37,0-.59-.07-1.07-.07-1.65,0-.61.47-.58.73-.92.13-.16.33-.14.51-.18Z"
          />
          <g id="text6390" className="cls-50">
            <text
              className="cls-51"
              transform="translate(29.51 98.4) rotate(159.23) scale(.83 -.99) skewX(8.38)"
            >
              <tspan x={0} y={0}>
                {"PioM"}
              </tspan>
            </text>
          </g>
          <path
            id="path6394"
            className="cls-39"
            d="M32.58,48.51c.26-.94.56-2.03,2.02-2.39,1.02-.26,2.05-1.11,2.94-1.47,1.31-.52,2.27-1.32,3.68-2.02,1.35-.68,2.44-2.3,1.84-3.5-.57-1.13-4.82-3.69-4.42-4.23,1.04-1.38,2.22-2.92,1.47-4.42-1.28-2.57-4.27.71-4.6,1.29-1.02,1.79,1.94,1.4,2.94,1.66.3.08.61.12.92.18.48.1.98.12,1.47.18.97.12.92,3.32.74,4.05-.39,1.58-2.39,1.54-2.39,3.68,0,1.09,1.18,2.37,1.79,3.13.53.66.28,1,.18,1.47"
          />
          <path
            id="path6396"
            className="cls-4"
            d="M37.92,47.39c.2.19-.26.79-.32.82-.63.21-.51-.58-.48-.69.06-.13.2-.22.34-.25.02,0,.43.03.46.12Z"
          />
          <path
            id="path6398"
            className="cls-46"
            d="M21.32,29.68c.08-2.25,2.74-2.57,4.01-2.61,2.81.12,4.82.84,7.79,3.58,1.22,1.23,2.08,2.79,3.31,3.98,1.46,1.71,2.42,4.2,2.3,6.71-.65,1.96-1.48,3.8-1.9,5.88-.11.43-.15.89-.08,1.33.02.12-.02.31.07.37.38.24.82.4,1.25.18.31-.15,1.13-.5,1.32-.82.24-.4.43-.86.81-1.1.4-.25.87-.53,1.25-1.01.37-.47.15-1.03.15-1.65,0-.48-.31-.97-.07-1.56.11-.29.45-.88.51-1.19.09-.42.29-1.01.07-1.56-.16-.39-.37-.8-.37-1.28,0-.55.15-.78.15-1.37,0-.68-.02-1.22-.37-1.65-.13-.16-.98-.87-1.03-1.1-.11-.53-.1-1.08-.22-1.47-.05-.15-.1-.31-.15-.46-.19-.58-.48-1.33-1.03-1.56-.38-.16-.69-.43-1.18-.73-.49-.3-.65-.47-.96-1.1-.35-.73-.72-1.14-1.4-1.56-.53-.33-1.24-.4-1.76-.73-.32-.2-.69-.54-.88-1.01-.16-.41-.25-.62-.66-.82-.47-.23-.83-.76-1.32-.92-.39-.12-.78-.24-1.18-.37-.37-.11-.84-.57-1.25-.82-.27-.17-.86-.82-1.18-.92-.58-.18-1.01,0-1.54,0-.57,0-1.08.2-1.54-.09-.32-.2-.78-.62-1.4-.37-.35.15-.88.27-1.1.55-.27.34-.71.58-.88,1.01-.19.48-.37.82-.51,1.19-.21.52-.15.76-.15,1.37,0,.32.08,1.38.22,1.74.14.34.33,1.24.59,1.56.1.12.2.24.29.37Z"
          />
          <path
            id="path6400"
            className="cls-34"
            d="M34.04,78.75l4.38,3.8c-1.28,4.01-6.29,7.16-7.22,6.71l-.66-8.19,1.65,7.65-1.21-7.96,1.94,7.27-1.52-7.81,2.51,7.24-2.01-7.54,2.99,6.5-2.56-6.83,3.51,6.16-3.2-6.63,3.98,6.02-3.62-6.11,4.12,5.31-3.67-5.59,4.24,4.42-3.67-4.43Z"
          />
          <path
            id="path6402"
            className="cls-34"
            d="M23.35,80.8l-.72,6.9c-4,1.45-6.12-2.85-8.23-5.17l5.7-4.01-4.59,4.78,5.04-4.33-4.33,5.01,4.98-4.81-4.16,5.53,4.88-5.4-3.97,5.92,4.16-5.37-3.51,6.24,3.87-5.89-2.8,6.5,3.09-6.37-2.11,6.67,2.44-6.5-1.5,6.57,1.76-6.28Z"
          />
          <path
            id="path6404"
            className="cls-13"
            d="M27.66,70.74c.61.24,1.88.17,2.69.41.41.02.76,1.2.51,1.42-.44.4-1.13.59-1.8.61-.36.01-1.74-.31-2.14-.31-1.02,0-1.22-1.03-.97-1.34.31-.37,1.06-.88,1.71-.77Z"
          />
          <path
            id="path6406"
            className="cls-13"
            d="M27.87,71c.47.2,1.44.15,2.07.35.32.02.58,1.02.39,1.21-.34.34-.87.5-1.38.52-.28.01-1.34-.26-1.65-.26-.79,0-.94-.88-.74-1.15.24-.31.82-.75,1.32-.66Z"
          />
          <path
            id="path6408"
            className="cls-13"
            d="M28.12,71.53c.35.15,1.08.11,1.55.25.24.01.44.74.29.87-.25.25-.65.36-1.04.37-.21,0-1-.19-1.24-.19-.59,0-.7-.63-.56-.82.18-.23.61-.54.99-.48Z"
          />
          <path
            id="path6410"
            className="cls-13"
            d="M28.08,71.81c.28.11.87.08,1.24.19.19,0,.35.58.24.68-.2.19-.52.28-.83.29-.17,0-.8-.15-.99-.15-.47,0-.56-.5-.45-.65.15-.18.49-.42.79-.37Z"
          />
          <path
            id="path6412"
            className="cls-13"
            d="M28.08,72c.18.09.57.07.82.16.13,0,.23.47.15.55-.13.16-.34.23-.55.24-.11,0-.53-.12-.65-.12-.31,0-.37-.4-.29-.53.1-.14.32-.34.52-.3Z"
          />
        </g>
        <path
          id="path5808"
          className="cls-2"
          d="M29.14,165.71l3.8,8.76,4.68,14.94-2.22-3.99-3.18-9.79-3.08-9.92Z"
        />
        <path
          id="path5806"
          className="cls-2"
          d="M21.07,137.85l3.25,8.98,3.74,15.2-1.97-4.12-2.57-9.97-2.46-10.09Z"
        />
        <path
          id="path5804"
          className="cls-2"
          d="M32.51,107.4l-3.26,8.98-6.86,14.07,1.12-4.42,4.41-9.3,4.58-9.32Z"
        />
        <path
          id="path5814"
          className="cls-2"
          d="M97.92,95.03l.52,9.3,2.53,14.95.21-4.48-1.56-9.86-1.71-9.91Z"
        />
        <path
          id="path5818"
          className="cls-2"
          d="M96.99,161.58l-3.8,8.76-4.68,14.94,2.22-3.99,3.18-9.79,3.08-9.92Z"
        />
        <path
          id="path5816"
          className="cls-2"
          d="M105.06,133.72l-3.25,8.98-3.74,15.2,1.97-4.12,2.57-9.97,2.46-10.09Z"
        />
        <path
          id="path5812"
          className="cls-2"
          d="M93.16,75.95s-1.01-1.29-1.09-.75c-.13.89.07,2.08.07,2.08l3.95,13.27s.9-.1-.7-4.72c-3.38-9.76-2.23-9.88-2.23-9.88Z"
        />
        <path
          id="path4925"
          className="cls-18"
          d="M66.62,219.79c-.1,2.26.32,10.02.11,11.29-.14.88-1.52,1.76-2.41,1.75-1.1,0-3.02-1.09-2.96-2.19.14-2.37-.46-9.54-.44-10.85.05-2.58-7.46-5.88-10.52-8.66-2.33-2.11-5.3-5.15-7.01-7.78-1.45-2.23-3.33-5.46-3.62-8.11-.2-1.8.49-4.25,1.21-5.92,1.2-2.8,3.46-6.39,5.81-8.33,2.33-1.92,6.26-3.41,9.21-4.06,4.53-.99,10.89-1.05,15.45-.22,2.12.39,4.84,1.51,6.69,2.63,2.49,1.51,5.33,4.25,7.34,6.36.84.88,2.1,2.03,2.52,3.18.82,2.26.87,5.69.22,8-.64,2.26-2.83,4.72-4.27,6.58-2.89,3.71-7.22,7.84-10.52,11.18-.76.76-6.68,2.68-6.8,5.15Z"
        />
        <path
          id="path4927"
          className="cls-35"
          d="M82.07,186.8c-3.43-4.37-12.43-4.52-17.98-4.38-5.08.13-12.47,1.4-16.22,4.82-2.09,1.91-4.15,6.01-3.51,8.77,1.53,6.53,10.11,13.48,16.66,14.91,3.9.85,9.44-1.65,12.71-3.95,3.38-2.37,7.01-7.05,8.33-10.96.88-2.62,1.71-7.03,0-9.21Z"
        />
      </g>
    </g>
  </svg>
);
export default KidneySVG;
